import { noop } from "lodash";
import { t } from "@/i18n-js/instance";

interface SearchProps {
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const Search = ({ onChange = noop }: SearchProps) => (
  <input
    type="search"
    placeholder={t("media_player.search")}
    className="shadow-xs placeholder:text-light border-primary w-full rounded-lg placeholder:opacity-100"
    onChange={onChange}
  />
);
